/**
 * 插件开发注意事项三
 *   3.1除了一个methods中的初始化插件的方法意外，其他函数（methods）和变量（data）都不写在methods和data里，统一写在类里
 *      这样做的原因是为了用一个类来形成一个命名空间，最大程度的减小了 当插件很多的时候 mixin以后组件间的命名冲突的问题
 *   3.2computed也统一用工厂函数来实现
 *   3.3所有需要的变量都统一存储在类中的constructor中,如果有需要在类中的方法中调用vue中的this，请在methods函数中的插件初始化函数里
 *      把this传进去，不要使用call、apply改变this指向，因为再类里不仅有需要用到vue的this的情况，也有用到类的this的情况
 */
class ChartOption3AxisLenControl {
  /**
   *
   * @param {Object} opt chartoption对象
   * @param {String} axis 轴类型，x轴就传入'x'字符串，y轴就传入'y'字符串
   */

  initAxisValueLengthControl(content, opt, axis) {
    //如果需要控制字符串长度才执行后续逻辑
    if (content.hasProperty(opt[axis + "Axis"], "dataValueLengthControl")) {
      if (content.hasProperty(opt, `${axis + "Axis"}.data`)) {
        opt[axis + "Axis"].data.forEach((item, index) => {
          const strLen = opt[axis + "Axis"].dataValueLength
          if (!content.hasProperty(item, "realValue")) {
            content.$changeOptionsEV(item.value, `chartOption.${axis + "Axis"}.data.${index}.realValue`, false)
            item.realValue = item.value
          }
          // item.value = item.realValue.length > strLen ? item.realValue.slice(0, strLen) + "..." : item.realValue
          item.value = item.realValue
        })
      }
    }
  }
  clearRealValue(content, opt, axis) {
    opt[axis].data.forEach((item, index) => {
      if (item.realValue) {
        content.$changeOptionsEV(item.realValue, `chartOption.${axis}.data.${index}.value`, false)
      }
    })
  }
}
//柱状图轴上文字长度控制插件
export default {
  data() {
    return {
      chartOption3AxisLenControl: new ChartOption3AxisLenControl()
    }
  },
  watch: {
    //插件开发注意事项一：1.1当插件中使用了watch或者computed或者定时器，用来在某些时间点对!!插件函数(一定是插件函数)!!进行调用的话，
    //                   1.2！！一定要！！做一次判断，判断当前组件的插件名数组（pluginName）里是否还有当前插件
    "options.chartOption.yAxis.data": {
      deep: true,
      handler(newVal, oldVal) {
        // const opt = this.options.chartOption
        // if (opt.pluginName.find(it => it === "axisLenControlPlugin")) {
        //   this.axisLenControlPlugin(opt)
        // }
      }
    },
    "options.chartOption.pluginName": {
      deep: true,
      handler(n, o) {
        if (n && !n.find(it => it === "axisLenControlPlugin")) {
          const opt = this.options.chartOption
          try {
            if (opt.seriesTempAttributes.coordinateType === "rectangular") {
              // 直角坐标系才有x、y轴
              if (opt.xAxis?.data?.length) {
                this.chartOption3AxisLenControl.clearRealValue(this, opt, "xAxis")
              }
              if (opt.yAxis?.data?.length) {
                this.chartOption3AxisLenControl.clearRealValue(this, opt, "yAxis")
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
      }
    }
  },
  methods: {
    /**
     * 插件开发注意事项二：
     * 2.1. opt对象是chartoption对象，也就是echarts接收的配置项参数
     * 2.2. 插件名，例如这里的axisLenControlPlugin函数的函数名，一定要与charoption里的pluginName数组中的对应元素一致
     * 2.2  axisLenControlPlugin函数是当前插件的入口函数，一切的插件动作都在当前函数内完成
     * 2.3  echarts的插件仅仅用于配置项无法实现或者难以实现的特殊样式，仅仅用来处理chartoptions对象内的内容
     * 2.4  !!!!注意！一个插件中的methods有且仅能有一个方法，其他方法均写在最顶部的类中，具体原因请看》插件开发注意事项三
     * @param {object} opt
     */
    chartOption3AxisLenControlPlugin(opt) {
      this.chartOption3AxisLenControl.initAxisValueLengthControl(this, opt, "y") //初始化轴文字长度控制
      this.chartOption3AxisLenControl.initAxisValueLengthControl(this, opt, "x") //初始化轴文字长度控制
    }
  }
}
